import {useAppDispatch} from "./reduxHooks.ts";
import {navigationReducerActions} from "../reducer/navigationReducer.ts";
import {useEffect} from "react";

const useDirtyBlockerReset = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(navigationReducerActions.resetAll());
    }, [dispatch]);
};

export default useDirtyBlockerReset;
